import React from 'react';

const SummaryCardGroup = ({ items = [] }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
    {items.map((item) => (
      <div
        key={item.label}
        className="rounded-md border border-[rgba(15,23,42,0.1)] bg-surface-grouped px-4 py-3.5 shadow-primeSm"
      >
        <div className="flex flex-col gap-1">
          <span className="text-xs font-bold uppercase tracking-wide text-label-tertiary">{item.label}</span>
          <span
            className="text-2xl font-extrabold tabular-nums text-label-primary"
            style={item.color ? { color: item.color } : undefined}
          >
            {item.value}
          </span>
          {item.helper && <span className="text-xs text-label-secondary">{item.helper}</span>}
        </div>
      </div>
    ))}
  </div>
);

export default SummaryCardGroup;
